<template>
  <div class="payment-methods-list">
    <div
      class="payment-methods-list__block"
      v-for="(method, idx) in list"
      :key="`new-${idx}`"
      :class="{
        selected: checkSelected(method)
      }"
      @click="$emit('select', method, !!method.percent)"
    >
      <div class="payment-methods-list__block__info">
        <p v-if="method.percent" class="commission">{{ getCommissionNewLava(method.percent) }}%</p>
        <p v-if="method.currency" class="currency">{{ method.currency }}</p>
        <p v-if="method.commission" class="commission">{{ getCommission(method.commission) }}%</p>
      </div>
      <img :src="getMethodIcon(method)" alt="payment-icon" />
    </div>
  </div>
</template>

<script>
import { getCommissionNewLava } from '@/utils/formatting'

const NEW_COMMISSION_ICON = {
  mir_card: 'lava_card',
  card: 'card_3',
  sbp: 'sbp_3'
}

export default {
  name: 'PaymentMethodsList',

  props: {
    list: {
      type: Array
    },
    current: {
      type: String,
      default: ''
    }
  },
  methods: {
    getCommissionNewLava,
    getMethodIcon(method) {
      let name = method.iconName || method.name || method.key
      const isRubCardIcon = name === 'lava_card' || name === 'cardlink'
      let icon = method.iconType || 'png'

      if (method.method) {
        icon = method.method === 'mir_card' ? 'png' : 'svg'
        name = NEW_COMMISSION_ICON[method.method]
      }
      if (isRubCardIcon) name = 'rub_card'
      if (!name) return ''

      return require(`@/assets/images/payments/methods/${name}.${icon}`)
    },
    checkSelected(method) {
      if (!this.current) return
      return method.key === this.current || method.method === this.current
    },
    getCommission(value) {
      return value?.toFixed(1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './payment-methods-list';
</style>
